import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectStrategyParametersWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).strategyParameters;

export const selectStrategyParametersState = (
    state: State,
    widgetKey: string
) => selectStrategyParametersWidgetsState(state)[widgetKey];
